import loadable from '@loadable/component';

export const ExpiredEventPageLoadable = loadable(
  () => import('./ExpiredEventPage'),
  {
    resolveComponent: (module) => module.ExpiredEventPage,
  },
);
